module.exports = __webpack_public_path__ + "static/media/image2.06dcac1a.jpg";